import React from "react";

const FridaySms = () => {
  return (
    <section id="friday-sms" className="py-20 md:py-32 lg:py-40">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex justify-between items-center align-top gap-12 lg:gap-20 ">
          <div className="max-w-xl">
            <h2 className="text-3xl text-center md:text-left sm:text-5xl text-text-primary mb-5">
              Friday morning. One number. No spreadsheet.
            </h2>
            <p className="text-lg text-center md:text-left md:text-xl text-text-secondary leading-[1.6]">
              Repayas sends your Safe-to-Spend figure by SMS every Friday at
              10am, giving you a simple weekend cash control habit without
              opening another app.
            </p>
          </div>
          <div className=" hidden lg:flex lg:justify-end">
            <div className="w-full max-w-[320px]">
              <div className="bg-[#0F0F0F] rounded-[40px] p-3">
                <div className="bg-white rounded-4xl overflow-hidden">
                  <div className="flex items-center justify-between px-6 py-3 bg-[#F5F4F2]">
                    <span className="text-xs font-medium text-[#0F0F0F]">
                      9:41
                    </span>
                    <div className="flex items-center gap-1">
                      <svg
                        className="h-4 w-4 text-[#0F0F0F]"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 18c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6z"></path>
                      </svg>
                      <svg
                        className="h-4 w-4 text-[#0F0F0F]"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M17 4h-3V2h-4v2H7v18h10V4zm-4 16h-2v-2h2v2zm0-4h-2V8h2v8z"></path>
                      </svg>
                    </div>
                  </div>
                  <div className="px-4 py-6 min-h-75">
                    <div className="text-center mb-6">
                      <span className="text-xs text-[#6B6B6B]">
                        Today 10:00
                      </span>
                    </div>
                    <div className="bg-[#F5F4F2] rounded-2xl rounded-tl-sm p-4 max-w-65">
                      <p className="text-sm text-[#0F0F0F] font-medium mb-2">
                        Repayas
                      </p>
                      <p className="text-sm text-[#0F0F0F] leading-relaxed">
                        Your Safe-to-Spend today is{" "}
                        <span className="font-semibold">£3,247</span>.
                      </p>
                      <p className="text-sm text-[#0F0F0F] leading-relaxed mt-2">
                        Confidence:{" "}
                        <span className="text-[#16A34A] font-medium">High</span>
                      </p>
                      <p className="text-sm text-[#0F0F0F] leading-relaxed mt-2">
                        VAT still to protect: £2,647
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FridaySms;
